import { useContext } from "react"

import {
  OrganizationSubscriptionPlanPermissionsContext,
  OrganizationSubscriptionPlanPermissionsContextType,
} from "~/pages/Brand/CommunicationStudio/contexts/organizationSubscriptionPlanPermissions/OrganizationSubscriptionPlanPermissionsContext"

export const useOrganizationSubscriptionPlanPermissions =
  (): OrganizationSubscriptionPlanPermissionsContextType => {
    const context = useContext(OrganizationSubscriptionPlanPermissionsContext)
    if (context === undefined) {
      throw new Error(
        "useOrganizationSubscriptionPlanPermissions must be used within an OrganizationSubscriptionPlanPermissionsProvider"
      )
    }
    return context
  }
